import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from '@emotion/styled';
import Spinner from '@impargo/components/Spinner';
const Splash = ({ className }) => (_jsx("div", Object.assign({ className: className, "data-testid": 'splash-screen' }, { children: _jsx(Spinner, { margin: '0px' }) })));
export default styled(Splash) `
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpointDesktop}) {
    position: fixed;
    top: 50%;
    transform: translateY(-50%);
    background-color: ${({ theme }) => theme.colorSurfaceHc};
  }
`;
